//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export module irepr {

/** Object that stores National Incomes Register Earnings Payment Reports. */
export interface EarningsPayment {
    /** Delivery data from IR Wage Report. */
    deliveryData?: DeliveryData | null;
    /** Salaxy data that can't be stored in Earnings Payment Report */
    info?: EarningsPaymentReportExtensions | null;
    /** Validation for the Earnings Payment Report */
    validation?: ApiValidation | null;
    /** Status of the Earnings Payment Report. */
    status?: EarningsPaymentReportStatus | null;
    /** IR Report log. Successfully sent or canceled report ids and time stamps. */
    reportLog?: ReportLogEntry[] | null;
    /** Last errors from IR. */
    irErrors?: ApiValidation | null;
    /** Last successful status in Incomes Register */
    irStatus?: ReportLogEventType | null;
    /** Current schedule for the report. */
    scheduledFor?: string | null;
    /** Timestamp of the last action in IR. */
    lastDeliveredAt?: string | null;
    /** If true, the report has been modified after the last send operation. */
    isModified?: boolean | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Record data */
export interface DeliveryData {
    /** Time of record creation */
    timestamp?: string | null;
    /** Data source */
    source?: string | null;
    /** Record type */
    deliveryDataType?: DeliveryDataType | null;
    /** Record owner's (payer's) record reference

The record owner's record reference must uniquely identify all records of a specific record owner (DeliveryDataOwner) containing earnings payment reports (DeliveryDataType=100). */
    deliveryId?: string | null;
    /** Rule for processing invalid data (reports)

If the record contains invalid reports, this entry determines whether to reject only the invalid reports in the record or the entire record */
    faultyControl: FaultyControl;
    /** Production environment

If the value is "true", the data must have been delivered to the Incomes Register's production environment. If the value is "false", the data must have been delivered to the Incomes Register's test environment. */
    productionEnvironment?: boolean | null;
    /** Record owner

Processing rules related to data items Record owner, Record creator and Record submitter:

The payer has a customer ID and the payer reports the data:
At least one identifier has been specified in the data group Payer identifiers. The data item Record owner must be one of the payer identifiers. If a business ID has been specified in the data group Payer identifiers, it must be specified as the Record owner.
The Record owner (= payer) must be specified as the Record creator.
The Record owner (= payer) must be specified as the Record submitter.

The payer has a customer ID and the service provider submits the data on behalf of the payer:
At least one identifier has been specified in the data group Payer identifiers. The data item Record owner must be one of the payer identifiers. If a business ID has been specified in the data group Payer identifiers, it must be specified as the Record owner.
The identifier of the service provider must be specified as the Record creator. If the service provider has a business ID, it must be specified. It must be specified in the Incomes Register that the service provider has the right to submit records on behalf of others.
The Record creator (= service provider) must be specified as the Record submitter.

The payer has no customer ID and the service provider submits the data on behalf of the payer:
The value of the data item "The payer does not have a customer ID" is "true".
The identifier of the service provider must be specified as the Record owner. If the service provider has a business ID, it must be specified. It must be specified in the Incomes Register that the service provider has the right to submit records on behalf of others.
The Record owner (= service provider) must be specified as the Record creator. */
    deliveryDataOwner?: Id | null;
    /** Record creator

The processing rules for Identifier type, Identifier, Country code and Country name are the same as in the Record owner (DeliveryDataOwner) data group. */
    deliveryDataCreator?: Id | null;
    /** Record submitter

The processing rules for Identifier type, Identifier, Country code and Country name are the same as in the Record owner (DeliveryDataOwner) data group. */
    deliveryDataSender?: Id | null;
    /** Pay period */
    paymentPeriod?: PaymentPeriod | null;
    /** Contact persons for the record */
    contactPersons?: ContactPerson[] | null;
    /** Payer details */
    payer?: Payer | null;
    /** Reports data */
    reports?: Report[] | null;
}

/** Salaxy data that can't be stored in earnings payment report */
export interface EarningsPaymentReportExtensions {
    /** Worker */
    worker?: Avatar | null;
    /** Calculation used to generate this WageReport */
    calculationId?: string | null;
    /** Employer's Id */
    employerId?: string | null;
    /** Worker's Id */
    workerId?: string | null;
    /** Partner of the customer. */
    partnerId?: string | null;
    /** Service model of the customer. */
    serviceModelId?: string | null;
    /** Payment Channel of the calculation. */
    paymentChannel?: EarningsPaymentReportExtensionsPaymentChannel | null;
    /** Application from which the calculation originated. */
    applicationId?: string | null;
    /** Assumed earnings payment report date for the report. */
    reportDate?: string | null;
}

/** Common base class / interface for data validation. */
export interface ApiValidation {
    /** If true, the data is valid - no errors. */
    readonly isValid?: boolean | null;
    /** If true, has required fields missing data. */
    readonly hasAllRequiredFields?: boolean | null;
    /** Validation errors on invalid field values. 
Note that required fields missing error messages are not here. Only the invalid values. */
    readonly errors?: ApiValidationError[] | null;
}

/** Log data from the successfull sending or cancellation. */
export interface ReportLogEntry {
    /** Response date from the Incomes Register. */
    irTimestamp?: string | null;
    /** Event type: Sending or cancellation. */
    eventType?: ReportLogEventType | null;
    /** Our own report id. */
    reportId?: string | null;
    /** Generated id from the Incomes Register. */
    irReportId?: string | null;
    /** Delivery id. */
    irDeliveryId?: string | null;
    /** Response id. */
    irResponseId?: string | null;
    /** Version. */
    irVersion?: number | null;
    /** User who sent the report. */
    user?: string | null;
    /** Credential of the user. */
    credential?: string | null;
    /** Storage version id. */
    versionId?: string | null;
    /** Message for the event. */
    message?: string | null;
}

/** Defines the data that IWorkflowItem must provide. */
export interface WorkflowData {
    /** Workflow events for the item. */
    events?: WorkflowEvent[] | null;
}

/** Employer Identifier */
export interface Id {
    /** Identifier type */
    type?: IdType | null;
    /** Identifier

If the "Identifier type" is "Business ID", the identifier must exist (according to information from the Business Information System (YTJ)).
If the "Identifier type" is "Finnish Personal Identification Number", the identifier must exist (according to information from the Population Information System (VTJ)). */
    code?: string | null;
    /** Country code

Mandatory data if "Identifier type" is other than "Business ID" or "Finnish Personal Identification Number". */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99". */
    countryName?: string | null;
}

/** Pay Period If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
export interface PaymentPeriod {
    /** Date of payment or other report

The date must not be earlier than 1 January 2019. */
    paymentDate?: string | null;
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The date must not be earlier than the "Start date". */
    endDate?: string | null;
}

export interface ContactPerson {
    /** Name */
    name?: string | null;
    /** Telephone number */
    telephone?: string | null;
    /** E-mail address

If the ‘Reimbursement application data’ data group is specified for a paid absence and 1 or 2 as the ‘Payment data type’ even in a single report in a record, you must report at least one ‘Contact person for the record’ for whom the ‘E-mail address’ and ‘Field of responsibility’ data items have been specified. */
    email?: string | null;
    /** Field of responsibility

If the ‘Reimbursement application data’ data group is specified for a paid absence and 1 or 2 as the ‘Payment data type’ even in a single report in a record, you must report at least one ‘‘Contact person for the record’ for whom the ‘E-mail address’ and ‘Field of responsibility’ data items have been specified, with ‘Field of responsibility’ having the value 1 (Content issues). */
    responsibilityCode?: ResponsibilityCode | null;
}

/** Payer details */
export interface Payer {
    /** Payer identifiers */
    payerIds?: Id[] | null;
    /** Basic payer details */
    payerBasic?: PayerBasic | null;
    /** Payer's address */
    address?: Address | null;
    /** Payer's suborganisations */
    subOrgs?: SubOrg[] | null;
    /** Other payer details */
    payerOther?: PayerOther | null;
    /** Substitute payer */
    substitutePayer?: SubstitutePayer | null;
}

/** Report data */
export interface Report {
    /** Service data */
    reportData?: ReportData | null;
    /** Income earner details */
    incomeEarner?: IncomeEarner | null;
    /** Income types */
    transactions?: Transaction[] | null;
    /** Details on foreign leased workforce */
    foreignLeasedWork?: ForeignLeasedWork | null;
    /** Stay periods in Finland */
    stayPeriodsInFinland?: StayPeriodsInFinland | null;
    /** Work periods in Finland */
    workPeriodsInFinland?: WorkPeriodInFinland[] | null;
    /** Countries of work */
    workCountries?: WorkCountry[] | null;
    /** Absences */
    absence?: Absence | null;
}

/** Defines an avatar for an account, profile etc. - mainly the image that should be shown, names and short description */
export interface Avatar {
    /** Entity type: person/company */
    entityType?: AvatarEntityType | null;
    /** First name or company name */
    firstName?: string | null;
    /** Last name, for companies, this should be null */
    lastName?: string | null;
    /** Display name. For a person this is 'FirstName LastName' (auto-created). */
    displayName?: string | null;
    /** Sortable name for ordered lists etc. For a person this is 'LastName, FirstName' (auto-created).
Depending on the data storage, this may be all-lowercase for easier sorting and search. */
    sortableName?: string | null;
    /** Type of the Avatar picture. */
    pictureType?: AvatarPictureType | null;
    /** Color - currently only used by type Icon */
    color?: string | null;
    /** Initials - currently only used by type Icon */
    initials?: string | null;
    /** URL of the picture if specified as picture (null in a case of type Icon) */
    url?: string | null;
    /** Short description of the user. 
This may be overriden by a context specific value by the business logic. */
    description?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Validation errors used in API output. */
export interface ApiValidationError {
    /** Full path to Name of the property / field (Member name in JSON).
This may be null/empty for type General. */
    key?: string | null;
    /** High level type: Specifies the relation to object and its Member. */
    type: ApiValidationErrorType;
    /** Validation error message in the requested language. */
    msg: string;
    /** Validation error long description in the requested language. */
    description?: string | null;
    /** Some error providers may have a unique technical code for error or validator */
    code?: string | null;
}

/** Event in the workflow */
export interface WorkflowEvent {
    /** Event-provider specific identifier for the event.
For deletable events, this should identify , but do NOT trust this to be 100% unique. */
    id?: string | null;
    /** Type of the event. This typically maps to parent-object specific enumeration. */
    type?: string | null;
    /** Message for backoffice purposes from the User or system that created the event. */
    message?: string | null;
    /** User Interface styling of the event: Indicates the severity for the end-user. */
    ui?: WorkflowEventUi | null;
    /** Features for this event. */
    features?: Features[] | null;
    /** UTC time for when the event occured. */
    time?: string | null;
    /** User or system that created the event. */
    user?: string | null;
    /** Credential of the user which is responsible of the event. */
    assignedTo?: string | null;
    /** Record attached to this event. */
    record?: string | null;
}

/** Basic payer details */
export interface PayerBasic {
    /** The payer does not have a customer ID

Mandatory data, if no identifiers have been specified in the "Payer identifiers" data group. */
    missingId?: boolean | null;
    /** Company name

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Last name" and "First name" have not been specified.
• The value of "The payer does not have a customer ID" is "true", and "Last name" and "First name" have not been specified. */
    companyName?: string | null;
    /** Last name

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Company name" has not been specified.
• The value of "The payer does not have a customer ID" is "true", and "Company name" has not been specified.
• The value of "Payer type" is "Temporary employer", and "Company name" has not been specified. */
    lastName?: string | null;
    /** First name

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Company name" has not been specified.
• The value of "The payer does not have a customer ID" is "true", and "Company name" has not been specified.
• The value of "Payer type" is "Temporary employer", and "Company name" has not been specified. */
    firstName?: string | null;
    /** Date of birth

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Last name" and "First name" have been specified.
• The value of "The payer does not have a customer ID" is "true", and "Last name" and "First name" have been specified.
The date must not be later than the current date.
The date must not be earlier than 1 January 1800 */
    birthDate?: string | null;
    /** Contact language */
    language?: Language | null;
}

/** Address */
export interface Address {
    /** c/o */
    co?: string | null;
    /** Street address

If this data group is included, either "Street address" or "P.O. Box" must be specified.Both must not be entered. */
    street?: string | null;
    /** P.O. Box

If this data group is included, either "Street address" or "P.O. Box" must be specified.Both must not be entered. */
    poBox?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City */
    postOffice?: string | null;
    /** Country code

A two-character code in accordance with the ISO 3166 country codes.
If the country is unknown, the value "99" is entered. */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99" */
    countryName?: string | null;
}

/** Payer's suborganisations */
export interface SubOrg {
    /** Suborganisation’s identifier type */
    type?: PayerSubOrgType | null;
    /** Suborganisation identifier */
    code?: string | null;
}

/** Other payer details */
export interface PayerOther {
    /** Payer types */
    payerTypes?: PayerType[] | null;
}

/** Substitute payer If substitute payer data is specified, at least the "Acts as a substitute payer" and "Employer identifier" data must be specified. If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
export interface SubstitutePayer {
    /** Acts as a substitute payer */
    acts?: boolean | null;
    /** Employer identifier */
    employerId?: Id | null;
    /** Employer name

Mandatory data if "Identifier type" is other than "Business ID" or "Finnish Personal Identification Number". */
    employerName?: string | null;
    /** Paid as wage security */
    wageSec?: boolean | null;
}

/** Service data */
export interface ReportData {
    /** Action type */
    actionCode?: ActionCode | null;
    /** Incomes Register report reference */
    irReportId?: string | null;
    /** Report reference */
    reportId?: string | null;
    /** Report version number */
    reportVersion?: number | null;
}

/** Income earner details */
export interface IncomeEarner {
    /** Income earner identifiers

Mandatory data group, if "The income earner does not have a customer ID" has not been specified. 
The data group must not be included, if "The income earner does not have a customer ID" has been specified.

If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
    incomeEarnerIds?: Id[] | null;
    /** Basic income earner details

Mandatory data group in the following cases:
• No identifiers where "Identifier type" is "Business ID" or "Finnish Personal Identification Number" have been specified in the "Income earner identifiers" data group. */
    incomeEarnerBasic?: IncomeEarnerBasic | null;
    /** Income earner's addresses

Mandatory data group in the following cases:
• No identifiers where "Identifier type" is "Business ID" or "Finnish Personal Identification Number" have been specified in the "Income earner identifiers" data group.
• The value of "The income earner does not have a customer ID" is "true".
• The value of "Non-resident taxpayer" is "true". In this case, at least the address in home country ("Address type" is "Address in home country") must be specified for the income earner */
    addresses?: TypedAddress[] | null;
    /** Income earner's suborganisations */
    subOrgs?: SubOrg[] | null;
    /** Employment relationship data */
    employment?: Employment | null;
    /** Occupation

The "Occupational class or title" data group must always be specified for an income earner, with the "Occupational class or title identifier" in accordance with "Statistics Finland's classification of occupations" included, except in the following situations:

a) The report contains no income types that require specification of th "Occupational class or title" data group.This takes account of whether the income type is, by default, income subject to accident and occupational disease insurance (see the document, "Wages – Codes – Income types") and whether the income type in the report is exceptionally subject to accident and occupational disease insurance.In the report, the exceptions to the income type's default values are specified using the "Type of insurance information" and "Grounds for insurance contribution" entries. If "Type of insurance information" is "Subject to accident and occupational disease insurance contribution" and the corresponding "Grounds for insurance contribution" value is "true"/"false", the income type in the report is/is not income subject to accident and occupational disease insurance.

b) The value of "Acts as a substitute payer" is "true".

c) The report includes a "Type of exception to insurance" that is one of the following:
• No obligation to provide insurance (earnings-related pension, health, unemployment or accident and occupational disease insurance)
• No obligation to provide insurance(accident and occupational disease insurance)
• Not subject to Finnish social security(earnings-related pension, health, unemployment or accident and occupational disease insurance
• Not subject to Finnish social security(accident and occupational disease insurance)

The "Occupational class or title" data group must always be specified for an income earner, with the "Occupational class or title identifier" in accordance with "Trafi's titles" included, if the "Pension provider code" is 34.*
The "Occupational class or title" data group must always be specified for an income earner, with the "Occupational class or title identifier" in accordance with "Keva's titles" included, if the "Pension provider code" is 20, 30, 25, 24 or 29.*
The "Occupational class or title" data group must always be specified for an income earner, with the "Occupational class or title identifier" in accordance with "Bank of Finland's titles" included, if the "Pension provider code" is 27.*

* Exception: The "Occupational class or title" data group does not need to be specified, if "Type of exception to insurance" with one of the following values has been specified for the income earner:
• No obligation to provide insurance(earnings-related pension, health, unemployment or accident and occupational disease insurance)
• No obligation to provide insurance(earnings-related pension insurance)
• Not subject to Finnish social security(earnings-related pension, health, unemployment or accident and occupational disease insurance)
• Not subject to Finnish social security(earnings-related pension insurance) */
    professions?: Profession[] | null;
    /** Employment registration

The "Grounds for registration" data group must be specified, with the "Registration grounds identifier" in accordance with "Keva's grounds for registration" included, if the "Pension provider code" is 20, 30, 25, 24 or 29.
The "Grounds for registration" data group must be specified, with the "Registration grounds identifier" in accordance with "Bank of Finland's grounds for registration" included, if the "Pension provider code" is 27 */
    employmentRegs?: EmploymentReg[] | null;
    /** Income earner's place of business

If this data group is included, either "Place of business code" or address details must be specified.If the address details are specified, they must include at least "Street address", "Postal code" and "City". */
    placeOfBusiness?: PlaceOfBusiness | null;
    /** Earnings-related pension insurance */
    pensionInsurance?: PensionInsurance | null;
    /** Occupational accident insurance */
    accidentInsurance?: AccidentInsurance | null;
    /** Insurance exceptions

If the Type of exception to insurance = 11 (Voluntary earnings-related pension) has been specified for the income earner, the values 1, 3, 6 or 7 should not be specified for the Type of exception to insurance in the same report.

If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
    insuranceExceptions?: ExceptionCode[] | null;
    /** International situations */
    internationalData?: InternationalData | null;
    incomeEarnerOther?: IncomeEarnerOther | null;
}

/** Income type details */
export interface Transaction {
    /** General income type details */
    transactionBasic?: TransactionBasic | null;
    /** Insurance information */
    insuranceData?: TransactionInclusion[] | null;
    /** Earnings periods */
    earningPeriods?: EarningPeriod[] | null;
    /** Unit of the wages */
    unitWages?: UnitWage[] | null;
    /** Car benefit */
    carBenefit?: CarBenefit | null;
    /** Meal benefit */
    mealBenefit?: MealBenefit | null;
    /** Other fringe benefit */
    otherBenefit?: BenefitCode[] | null;
    /** Seafarer's income */
    sailorIncome?: SailorIncome | null;
    /** Additional details on recovery */
    recoveryData?: RecoveryData | null;
    /** Daily allowance */
    dailyAllowance?: AllowanceCode[] | null;
    /** Kilometre allowance */
    kmAllowance?: KmAllowance | null;
    /** Six-month rule */
    sixMonthRule?: SixMonthRule | null;
}

/** Details on foreign leased workforce */
export interface ForeignLeasedWork {
    /** Representative */
    representative?: Representative | null;
    /** Estimated pay amount

Mandatory data if a form for work abroad where "Form type" is "Employee leasing notice" has been included in the report.

The value must be greater than or equal to 0. */
    estAmount?: number | null;
    /** Finnish employers */
    finServiceRecipient?: FinServiceRecipient | null;
}

/** Stay periods in Finland */
export interface StayPeriodsInFinland {
    /** Report contains no stay periods in Finland */
    noStayPeriods?: boolean | null;
    /** Stay periods */
    period?: StayPeriod[] | null;
}

/** Work period in Finland */
export interface WorkPeriodInFinland {
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The date must not be earlier than the "Start date". */
    endDate?: string | null;
    /** Number of workdays in Finland

The value must be a non-negative integer. */
    workDays?: number | null;
}

/** Work country */
export interface WorkCountry {
    /** Code of country of work 

A two-character code inaccordance with the ISO3166 country codes.If the country isunknown, the value "99"is entered. */
    workCountryCode?: string | null;
    /** Name of country of work

Mandatory data if "Country code" is "99". */
    workCountryName?: string | null;
    /** Districts of work */
    workMunicipalities?: string[] | null;
    /** Address in country of work */
    workCountryAddress?: WorkCountryAddress | null;
    /** Principal

Mandatory data group, if a form for work abroad where "Form type" is "NT1" has been included in the report. */
    serviceRecipient?: ServiceRecipient | null;
    /** Stay periods in country of work

There may be several stay periods in the country of work. Mandatory data group, if a form for work abroad where "Form type" is "NT1" or "NT2" has been included in the report */
    stayPeriodsAbroad?: StayPeriod[] | null;
    /** Work periods abroad

Mandatory data group, if a form for work abroad where "Form type" is "NT2" has been included in the report. */
    workPeriodsAbroad?: Period[] | null;
    /** Country of work has taxing right

Mandatory data if a form for work abroad where "Form type" is "NT1" or "NT2" has been included in the report. */
    taxingRight?: boolean | null;
    /** Pay burdens the result of the employer’s permanent establishment in the country of work

Mandatory data if a form for work abroad where "Form type" is "NT1" or "NT2" has been included in the report. */
    burdensResultOfPE?: boolean | null;
    /** Pay per month

This data group may only be used if a form for work abroad, where "Form type" is "NT2", has been included in the report. */
    wagePerMonth?: number | null;
    /** Other remunerations and benefits

This data group may only be used if a form for work abroad, where "Form type" is "NT2", has been included in the report. */
    remunerations?: RemunerationCode[] | null;
}

/** Absences If the details on the time period for reporting absences are specified in the data group, both the Start date of the time period for reporting absences and the End date of the time period for reporting absences data items must be specified. */
export interface Absence {
    /** Start date of the time period for reporting absences

The date must not be earlier than 1 January 1800. */
    absenceRepStartDate?: string | null;
    /** End date of the time period for reporting absences

The "End date" may not be earlier than the "Start date". */
    absenceRepEndDate?: string | null;
    /** Unpaid absence

There may be several absence periods. */
    unpaidAbsence?: UnpaidAbsence | null;
    /** Paid absence

There may be several absence periods. */
    paidAbsence?: PaidAbsence | null;
}

/** Basic income earner details */
export interface IncomeEarnerBasic {
    /** The income earner does not have a customer ID */
    missingId?: boolean | null;
    /** Company name */
    companyName?: string | null;
    /** Last name */
    lastName?: string | null;
    /** First name */
    firstName?: string | null;
    /** Date of birth */
    birthDate?: string | null;
    /** Gender */
    gender?: Gender | null;
}

/** Income earner's address */
export interface TypedAddress {
    /** Address type */
    addressType?: AddressType | null;
    /** c/o */
    co?: string | null;
    /** Street address

If this data group is included, either "Street address" or "P.O. Box" must be specified.Both must not be entered. */
    street?: string | null;
    /** P.O. Box

If this data group is included, either "Street address" or "P.O. Box" must be specified.Both must not be entered. */
    poBox?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City */
    postOffice?: string | null;
    /** Country code

A two-character code in accordance with the ISO 3166 country codes.
If the country is unknown, the value "99" is entered.

Mandatory data in the following cases:
• No identifier where "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Income earner identifiers" data group.
• The value of "The income earner does not have a customer ID" is "true".
• The value of "Non-resident taxpayer" is "true". */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99". */
    countryName?: string | null;
}

/** Employment relationship data */
export interface Employment {
    /** Employed */
    employed?: boolean | null;
    /** Employment type

Mandatory data if a paid absence and the ‘Reimbursement application data’ data group for it are specified in the report, with 2 as the ‘Payment data type (Kela, family leave compensation). */
    employmentCode?: EmploymentCode | null;
    /** Duration of employment */
    termCode?: TermCode | null;
    /** Part-time %

The value must be a non-negative decimal number with a maximum value of 100.00. */
    partTime?: number | null;
    /** Regular agreed working hours per week

The value must be a non-negative decimal number with a maximum value of 168.00. */
    hoursPerWeek?: number | null;
    /** Forms of payment

This data group is mandatory if a paid absence and the ‘Reimbursement application data’ data group for it are specified in the report, with 1 or 2 as the ‘Payment data type’. */
    paymentTypes?: PaymentType[] | null;
    /** Employment period

Mandatory data group, if "Pension provider code" is 20, 24, 25, 29 or 30. This data group is mandatory if a paid absence and the ‘Reimbursement application data’ data group for it are specified in the report, with 1 or 2 as the ‘Payment data type’. */
    employmentPeriods?: Period[] | null;
    /** Termination of employment

Mandatory data group, if "Time of employment" with an "End date" has been specified in the report, and the "Pension provider code" is 20, 30, 25, 24, 29 or 29. */
    employmentEndings?: EmploymentEnding[] | null;
}

/** Occupational class or title */
export interface Profession {
    /** Type of occupational title or classification */
    type?: ProfessionType | null;
    /** Occupational class or title identifier */
    code?: string | null;
    /** Title (free text) */
    title?: string | null;
}

/** Grounds for registration An income earner can have several grounds for registration but only one value in accordance with the “Type of registration grounds” data item. */
export interface EmploymentReg {
    /** Type of registration grounds */
    type?: EmploymentRegType | null;
    /** Registration grounds identifier

If "Type of registration grounds" is "Keva's grounds for registration", the codeset must include the combination("Registration grounds identifier", "Pension provider code"), and must be valid on the date that is the value of "Payment date or other report date".

If "Type of registration grounds" is "Keva's grounds for registration", and the codeset requires the use of a specific "Occupational title or classification identifier" in connection with the specified "Registration grounds identifier" value, the codeset must include the combination("Registration grounds identifier", "Pension provider code") and must be valid on the date that is the value of "Payment date or other report date".

If "Type of registration grounds" has some other value, it must be included in the specified codeset.If the codeset includes a validity period, the value must be valid on the date that is the value of "Payment date or other report date" in the specified codeset */
    code?: string | null;
}

/** Place of business */
export interface PlaceOfBusiness {
    /** Place of business code */
    code?: string | null;
    /** Street address */
    street?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City */
    postOffice?: string | null;
    /** Country code */
    countryCode?: string | null;
    /** Country name */
    countryName?: string | null;
}

/** Earnings-related pension insurance This data group is mandatory, except in the following situations: a) The report contains no income types that require specifying a value for "Earnings-related pension insurance information". This takes account of whether the income type is, by default, income subject to earningsrelated pension insurance(see the document, "Wages – Codes – Income types") and also whether the income type in the report is exceptionally subject to earnings-related pension insurance.In the report, the exceptions to the income type's default values are specified using the "Type of insurance information" and "Grounds for insurance contribution" entries. If "Type of insurance information" is "Subject to earnings-related pension insurance contribution" and the corresponding "Grounds for insurance contribution" value is "true"/"false", the income type in the report is/is not income subject to earnings-related pension insurance. b) "Acts as a substitute payer" is "true". c) "Type of exception to insurance" is one of the following: • No obligation to provide insurance(earnings-related pension, health, unemployment or accident and occupational disease insurance) • No obligation to provide insurance(earnings-related pension insurance) • Not subject to Finnish social security (earnings-related pension, health, unemployment or accident and occupational disease insurance) • Not subject to Finnish social security(earnings-related pension insurance) Exception: Although the data group is not mandatory under items a to c, it must always be included if "Type of exception to insurance" is "Voluntary insurance in Finland(earnings-related pension insurance)". Employee's earnings-related pension insurance If "Employee's earnings-related pension insurance" is specified as the value of "Earnings-related pension insurance information", values must also be specified for "Pension provider code" and "Pension policy number". Pension insurance for farmers(MYEL) If "Pension insurance for farmers (MYEL)" is specified as the value of "Earningsrelated pension insurance information", values must not be specified for "Pension provider code" or "Pension policy number". Pension insurance for the self-employed(YEL) If "Pension insurance for the self-employed (YEL)" is specified as the value of "Earnings-related pension insurance information", values must not be specified for "Pension provider code" or "Pension policy number". If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
export interface PensionInsurance {
    /** Earnings-related pension insurance information */
    pensionActCode?: PensionActCode | null;
    /** Pension provider code */
    pensionProvIdCode?: PensionProvIdCode | null;
    /** Pension policy number */
    pensionPolicyNo?: string | null;
}

/** Occupational accident insurance If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
export interface AccidentInsurance {
    /** Occupational accident insurance company identifier */
    accInsProvId?: Id | null;
    /** Occupational accident insurance policy number */
    accInsPolicyNo?: string | null;
}

/** International situations */
export interface InternationalData {
    /** Social security certificate */
    postedCertCode?: InternationalDataPostedCertCode | null;
    /** Non-resident taxpayer 

If income type 412 or 362 is specified in the report, the value of the ‘Nonresident taxpayer’ data item must be ‘true’. */
    nonResident?: boolean | null;
    /** Country code of country of residence 

Mandatory data, if "Non-resident taxpayer" is "true". */
    nonResidentCountryCode?: string | null;
    /** Name of country of residence

Mandatory data if "Country code" is "99". */
    nonResidentCountryName?: string | null;
    /** Income subject to withholding */
    subToWithhold?: boolean | null;
    /** Tax-treaty country code

Mandatory data if the Type of additional income earner data (IncomeEarnerType) = "Income earner did not stay longer than 183 days in Finland during the Tax-Treaty-defined sojourn period". This data can only be specified if the Type of additional income earner data is the above-mentioned value.
The value must be valid on the date specified in the data item "Payment date or other report date". */
    taxTreatyCountryCode?: string | null;
    /** Forms for work abroad */
    workForm?: WorkForm[] | null;
}

export interface IncomeEarnerOther {
    /** Applicable collective agreement

The value must be valid on the date specified in the data item "Payment date or other report date". */
    cbaCode?: number | null;
    /** Additional income earner details */
    incomeEarnerTypes?: IncomeEarnerType[] | null;
    /** Payment data */
    payments?: Payment[] | null;
}

/** General details on the income type */
export interface TransactionBasic {
    /** Income type code 

If the ‘Income type code’ is 412 or 362, the value of the ‘Non-resident taxpayer’ data item must be ‘true’.
If the ‘Income type code’ is 334 (Meal benefit) and the value of the ‘Reimbursement for a meal benefit corresponds to taxable value(TaxValue)’ is ‘true’, and none of the income types 301, 302, 317, 330 or 343 have been specified in the report, the income type 407 must not be specified.
Income type 407 must not be specified if none of the following income types have been specified in the report: 301, 302, 317, 330 or 334.
Income type 419 must not be specified if none of the following income types have been specified in the report: 101−106, 201−207, 209-227, 230−239, 308, 315, 316, 320, 326, 336, 339, 351, 353−355, 359. */
    transactionCode?: number | null;
    /** Amount

If ‘Income type code’ is 102, 103, 104, 105 or 106, the value must not be greaterthan the amount reported for income type 101.

The Wages – Codes – Income types document lists the income types for which anegative Amount can be specified.A negative Amount must not be specified forother income types.

If the value of the ‘Reimbursement for a meal benefit corresponds to taxablevalue (TaxValue)’ data item specified for income type 334 is ‘true’, the amountis not mandatory.

If ‘Income type code’ is 401 (Compensation collected for car benefit), theamount must not be greater than the amount reported using income type 304(Car benefit).

If ‘Income type code’ is 407 (Reimbursement collected for other fringe benefits),the value must not be greater than the amount reported using one of thefollowing income types or the total amount reported using some of thefollowing income types: 301 (Housing benefit), 302 (Interest benefit for ahousing loan), 317 (Other fringe benefit), 330 (Telephone benefit) and 334(Meal benefit).

If ‘Income type code’ is 415 (Reimbursement for employer-subsidisedcommuter ticket), the amount must not be higher than the amount reportedusing income type 341 (Employer-subsidised commuter ticket, tax-exemptshare) or income type 342 (Employer-subsidised commuter ticket, taxableshare), or the total amount reported using these income types.

If ‘Income type code’ is 419 (Deduction before withholding), the value must notbe greater than the amount reported using one of the following income typesor the total amount reported using some of the following income types:101−106, 201−207, 209-227, 230−239, 308, 315, 316, 320, 326, 336, 339, 351,353−355, 359. */
    amount?: number | null;
    /** Payment other than money */
    noMoney?: boolean | null;
    /** One-off remuneration */
    oneOff?: boolean | null;
    /** Unjust enrichment 

The Wages – Codes – Income types document lists the income types for which the ‘Unjust enrichment’ data item must not be specified. */
    unjustEnrichment?: boolean | null;
    /** Recovery

The Wages – Codes – Income types document lists the income types for which the ‘Recovery’ data item must not be specified. */
    recovery?: boolean | null;
}

/** Insurance information */
export interface TransactionInclusion {
    /** Insurance information type */
    insuranceCode?: InsuranceCode | null;
    /** Grounds for insurance contribution */
    included?: boolean | null;
}

/** Earnings period */
export interface EarningPeriod {
    /** Start date

The date must not be earlier than 1 January 1800 */
    startDate?: string | null;
    /** End date

The date must not be earlier than the "Start date". */
    endDate?: string | null;
}

/** Unit wage */
export interface UnitWage {
    /** Unit price

The value must be non-negative. */
    unitPrice?: number | null;
    /** Number of units

The value must be non-negative. */
    unitAmount?: number | null;
    /** Unit */
    unitCode?: WageUnitCode | null;
}

/** Car benefit Mandatory data group, if the income type is "Car benefit". This data group may not be used with other income types. */
export interface CarBenefit {
    /** Car benefit type */
    carBenefitCode?: CarBenefitCode | null;
    /** Car age group */
    ageGroupCode?: AgeGroupCode | null;
    /** Odometer reading

The value must be greater than or equal to 0 */
    kilometers?: number | null;
    /** Car emissions value

The car emissions value must be greater than or equal to 0, and smaller than or
equal to 100. The car emissions value can only be reported if the payment date
or other reporting date is in 2022–2025. */
    emissionsValue?: number | null;
}

/** Meal benefit */
export interface MealBenefit {
    /** Reimbursement for a meal benefit corresponds to taxable value */
    taxValue?: boolean | null;
}

/** Seafarer's income */
export interface SailorIncome {
    /** Payment is seafarer's income */
    sailorIncomeProp?: boolean | null;
    /** Time of cross trade

Allowed valus: 1 - 12 */
    crossTradeTime?: number | null;
    /** Withdrawal period */
    withdrawalPeriod?: WithdrawalPeriod | null;
}

/** Additional details on recovery */
export interface RecoveryData {
    /** Recovery date

The date must not be earlier than 1 January 1800. */
    recoveryDate?: string | null;
    /** Withholding from the recovered amount */
    withhold?: number | null;
    /** Tax at source from the recovered amount */
    taxAtSource?: number | null;
    /** Original payment periods */
    origPaymentPeriods?: OrigPaymentPeriod[] | null;
}

/** Kilometre allowance */
export interface KmAllowance {
    /** Number of kilometres */
    kilometers?: number | null;
}

/** Six-month rule */
export interface SixMonthRule {
    /** Six-month rule is applicable */
    applicable?: boolean | null;
    /** Country code

A two-character code in accordance with the ISO 3166 country codes.
If the country is unknown, the value "99" is entered.

Mandatory data, if "Six-month rule is applicable" is "true". */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99". */
    countryName?: string | null;
}

/** Representative */
export interface Representative {
    /** Representative identifiers */
    representativeIds?: Id[] | null;
    /** Representative's name */
    name?: string | null;
    /** Representative's address */
    address?: Address | null;
    /** Representative acts as submitter */
    representativeReports?: boolean | null;
}

/** Finnish employer Mandatory data group if a form for work abroad where "Form type" is "Employee leasing notice" has been included in the report. */
export interface FinServiceRecipient {
    /** Employer identifiers */
    finServiceRecipientIds?: Id[] | null;
}

/** Stay period */
export interface StayPeriod {
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The date must not be earlier than the "Start date". */
    endDate?: string | null;
}

/** Address in country of work */
export interface WorkCountryAddress {
    /** c/o */
    co?: string | null;
    /** Street address

Either "Street address" or "P.O. Box" must be specified in this data group. Both must not be entered. */
    street?: string | null;
    /** P.O. Box

Either "Street address" or "P.O. Box" must be specified in this data group. Both must not be entered. */
    poBox?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City */
    postOffice?: string | null;
    /** Country code

A two-character code in accordance with the ISO 3166 country codes.
If the country is unknown, the value "99" is entered. */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99" */
    countryName?: string | null;
}

/** Principal */
export interface ServiceRecipient {
    /** Principal identifiers */
    serviceRecipientIds?: Id[] | null;
    /** Principal's name */
    name?: string | null;
    /** Principal's address */
    serviceRecipientAddress?: ServiceRecipientAddress | null;
}

/** Time of employment */
export interface Period {
    /** Start date 

The date must not be more than 45 days later than the current date. The date must not be earlier than 1 January 1800.

If a paid absence and the ‘Reimbursement application data’ data group for it are specified in the report, with 1 or 2 as the ‘Payment data type’, the ‘Start date’ of the period of employment must be no earlier than the ‘Start date’ of the period of paid absence in question. */
    startDate?: string | null;
    /** End date

The date must not be earlier than the "Start date". */
    endDate?: string | null;
}

/** Unpaid absence */
export interface UnpaidAbsence {
    /** Absence periods */
    unpaidAbsencePeriods?: UnpaidAbsencePeriod[] | null;
}

/** Paid absence */
export interface PaidAbsence {
    /** Absence periods */
    paidAbsencePeriods?: PaidAbsencePeriod[] | null;
}

/** Reason for the termination of employment An income earner can have several reasons for the termination of employment but only one value in accordance with the “Reason codes for termination of employment” data item. */
export interface EmploymentEnding {
    /** Reason codes for termination of employment

If the value is "Keva codes", the "Pension provider code" must be 20, 30, 25, 24 or 29.
If the value is "Bank of Finland codes", the "Pension provider code" must be 27. */
    type?: EmploymentEndingType | null;
    /** Reason code for termination of employment

If "Keva codes" are used for the reason codes, the codeset must include the combination("Reason code for the termination of employment", "Pension provider code") and it must be valid on the date that is the value of "Payment date or other report date". 
If some other reason codeset is used, it must include this data.If the codeset includes a validity period, the value must be valid on the date that is the value of "Payment date or other report date" in the specified codeset. */
    code?: string | null;
}

/** Payment data */
export interface Payment {
    /** Payment data type */
    paymentType?: RefPaymentType | null;
    /** Payment's reference number 

Mandatory data, if "Payment data type" is "Earnings-related pension provider". */
    paymentRef?: string | null;
    /** Payment specifier */
    paymentSpecifier?: string | null;
}

/** Withdrawal period */
export interface WithdrawalPeriod {
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The date must not be earlier than the "Start date". */
    endDate?: string | null;
}

/** Original payment period */
export interface OrigPaymentPeriod {
    /** Payment date

The date must not be earlier than 1 January 1800. The date must not be later than that of ‘Payment date or other report date’ on the report. */
    paymentDate?: string | null;
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The "End date" may not be earlier than the "Start date". */
    endDate?: string | null;
}

export interface ServiceRecipientAddress {
    /** c/o */
    co?: string | null;
    /** Street address */
    street?: string | null;
    /** P.O. Box */
    poBox?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City */
    postOffice?: string | null;
    /** Country code */
    countryCode?: string | null;
    /** Country name */
    countryName?: string | null;
}

/** Absence period */
export interface UnpaidAbsencePeriod {
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The "End date" may not be earlier than the "Start date". */
    endDate?: string | null;
    /** Number of days of absence 

The value must be a non-negative number. */
    absenceDays?: number | null;
    /** Cause of absence */
    causeCode?: UnpaidAbsenceCauseCode | null;
}

/** Absence period */
export interface PaidAbsencePeriod {
    /** Start date

The date must not be earlier than 1 January 1800. */
    startDate?: string | null;
    /** End date

The "End date" may not be earlier than the "Start date”

Mandatory data if 1 or 2 was specified as the ‘Payment data type’ in the ‘Reimbursement application data’ data group.

The time period between the ‘Start date’ and ‘End date’ of the absence period must not overlap by a single day with the absence period of another paid absence on the same report (‘Start date’ – ‘End date’).

The time period between the ‘Start date’ and ‘End date’ of the absence period must not overlap by a single day with the absence period of an unpaid absence in the same report(‘Start date’ – ‘End date’). */
    endDate?: string | null;
    /** Number of days of absence */
    absenceDays?: number | null;
    /** Absence continues, until when

"Absence continues, until when" may not be earlier than "Start date". */
    absenceUntil?: string | null;
    /** Cause of absence */
    causeCode?: PaidAbsenceCauseCode | null;
    /** Pay for period of paid absence

The value must be a non-negative number. */
    amount?: number | null;
    /** Reimbursement application data */
    reimbApp?: ReimbPayment[] | null;
    /** Additional reimbursement application data

You can enter freeform text as additional information. This information may be entered only when the ‘Reimbursement application data’ data group has been specified in connection with the absence period.In other situations, the additional information must not be specified. */
    paidAbsencePeriodInfo?: string | null;
}

/** Payment data */
export interface ReimbPayment {
    /** Payment data type

If ‘Payment data type’ = 1 (Kela, daily allowance application), the ‘Reason for unpaid absence’ must only be one of the following: 1 (illness), 3 (maternity, paternity or parental leave), 4 (special maternity leave) or 5 (rehabilitation).

If ‘Payment data type’ = 2 (Kela, family leave compensation), the ‘Reason for unpaid absence’ must be 3 (maternity, paternity or parental leave). */
    paymentType?: ReimbPaymentType | null;
    /** Payment's reference number */
    paymentRef?: string | null;
    /** Payment specifier */
    paymentSpecifier?: string | null;
}

/** Api Schedule Object */
export interface IrApiScheduleObject {
    /** Id of the object in the data storage to schedule */
    id?: string | null;
    /** The date when the object was created. */
    startAt?: string | null;
    /** Schedule action to take. */
    action?: IrScheduleAction | null;
    /** User context information. */
    userContext?: UserContext | null;
}

/** Current user context. */
export interface UserContext {
    /** Owner for this data */
    owner?: string | null;
    /** Owner ID for this data */
    ownerId?: string | null;
    /** Partner ID for this data */
    partnerId?: string | null;
    /** Login partner ID for this data */
    loginPartnerId?: string | null;
    /** Credential ID for this data */
    credentialId?: string | null;
    /** Users scope, currently only 'admin' supported. */
    scope?: string | null;
}

/** Version information for the API object. */
export interface VersionInfo {
    /** Identifier for the version. */
    versionId?: string | null;
    /** Operation which created the version. */
    operation?: string | null;
    /** Date and time when the version was created. */
    date?: string | null;
    /** User account  who created the version. */
    userAccount?: Avatar | null;
}

export interface PageResultOfEarningsPaymentListItem {
    items?: EarningsPaymentListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of earnings payments in the user interface. It contains all essential information of the report and is basis for searching, filtering and sorting. */
export interface EarningsPaymentListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: EarningsPaymentReportStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: EarningsPaymentData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Object that represents a Salaxy account. */
export interface AccountInIndex {
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** Earnings payment specific business data for index. */
export interface EarningsPaymentData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Current status in the Incomes Register. */
    irStatus?: ReportLogEventType | null;
    /** Date and time for the next scheduled delivery of the report. */
    scheduledFor?: string | null;
    /** Date and time for the first delivery of the report. */
    firstDeliveredAt?: string | null;
    /** Date and time for the last delivery of the report. */
    lastDeliveredAt?: string | null;
    /** Partner id for invoicing. */
    partnerId?: string | null;
    /** Service Model id for invoicing. */
    serviceModelId?: string | null;
    /** Payment channel for invoicing. */
    paymentChannel?: EarningsPaymentDataPaymentChannel | null;
    /** Application id for invoicing. */
    applicationId?: string | null;
    /** Assumed earnings payment report date for the report. */
    reportDate?: string | null;
}

export interface EarningsPaymentNotification {
    /** Taken schedule action. */
    action?: ReportLogEventType | null;
    /** Status response for the sent request. */
    statusResponse?: StatusResponse | null;
    /** Record data */
    deliveryData?: DeliveryData | null;
    /** Identifier of the object in the data storage. */
    id?: string | null;
}

/** Processing feedback data */
export interface StatusResponse {
    /** Record status */
    deliveryDataStatus?: StatusResponseDeliveryDataStatus | null;
    /** Incomes Register record reference

If the record has been saved in the Incomes Register, the reference assigned to the record by the Incomes Register is delivered in this element.The Incomes Register record reference uniquely identifies all records submitted to the Incomes Register.
If the record has not been saved in the Incomes Register, this data is blank. */
    irDeliveryId?: string | null;
    /** Approved items

The valid items submitted in the record are returned in this data group. */
    validItems?: Item[] | null;
    /** Rejected items 

The invalid items submitted in the record and rejected on the basis of itemspecific errors are returned in this data group. If all items in the record are rejected on the basis of record-level errors, the rejected items are not returned in this data group. */
    invalidItems?: Item[] | null;
    /** Message-level errors

This data group is used to return technical and authorisation errors.
If message-level errors are detected in a record submitted to the Incomes Register, the record is not processed further in the Incomes Register. In addition to message-level errors, the processing feedback cannot therefore contain any other errors(record-level errors, and rejected items and the errors related to them). */
    messageErrors?: ErrorInfo[] | null;
    /** Record-level errors

This data group is used to return errors related to the contents of record-level data.
Record-level errors apply to all items in the record.If there are record-level errors in the record, all items of the record are invalid and will not be saved in the Incomes Register.In such a case, the invalid items are not separately delivered in the "Rejected items" data group. */
    deliveryErrors?: ErrorInfo[] | null;
    /** Incomes Register message reference */
    irResponseId?: string | null;
    /** Processing feedback timestamp */
    irResponseTimestamp?: string | null;
}

export interface Item {
    /** Record submitter's reference

This element always appears in the data of an approved item. */
    itemId?: string | null;
    /** Incomes Register reference 

This element always appears in the data of an approved item. */
    irItemId?: string | null;
    /** Report version number 

The Incomes Register assigns version number 1 to a new report. The version number of a substitute report is the number of the substituted version + 1. */
    itemVersion?: number | null;
    /** Item Version specified */
    itemVersionSpecified?: boolean | null;
    /** Errors */
    itemErrors?: ErrorInfo[] | null;
}

/** Error information */
export interface ErrorInfo {
    /** Error code */
    errorCode?: string | null;
    /** Error code description */
    errorMessage?: string | null;
    /** Error details */
    errorDetails?: string | null;
}

/** ActionCode enumeration */
export enum ActionCode {
    NewReport = "newReport",
    ReplacementReport = "replacementReport",
}

/** AddressType enumeration */
export enum AddressType {
    AddressInHomeCountry = "addressInHomeCountry",
    AddressInTheCountryOfWork = "addressInTheCountryOfWork",
}

/** AgeGroupCode enumeration */
export enum AgeGroupCode {
    A = "a",
    B = "b",
    C = "c",
    U = "u",
}

/** AllowanceCode enumeration */
export enum AllowanceCode {
    MealAllowance = "mealAllowance",
    PartialDailyAllowance = "partialDailyAllowance",
    FullDailyAllowance = "fullDailyAllowance",
    InternationalDailyAllowance = "internationalDailyAllowance",
    TaxExemptReimbursementsAbroad = "taxExemptReimbursementsAbroad",
}

/** ApiValidationErrorType enumeration */
export enum ApiValidationErrorType {
    General = "general",
    Required = "required",
    Invalid = "invalid",
    Warning = "warning",
}

/** BenefitCode enumeration */
export enum BenefitCode {
    AccommodationBenefit = "accommodationBenefit",
    TelephoneBenefit = "telephoneBenefit",
    MealBenefit = "mealBenefit",
    OtherBenefits = "otherBenefits",
}

/** CalcGroup enumeration */
export enum CalcGroup {
    Undefined = "undefined",
    BaseSalary = "baseSalary",
    SalaryAdditions = "salaryAdditions",
    Benefits = "benefits",
    Expenses = "expenses",
    Deductions = "deductions",
    OtherNoPayment = "otherNoPayment",
    Totals = "totals",
    Disabled = "disabled",
}

/** CarBenefitCode enumeration */
export enum CarBenefitCode {
    LimitedCarBenefit = "limitedCarBenefit",
    FullCarBenefit = "fullCarBenefit",
}

/** DeliveryDataType enumeration */
export enum DeliveryDataType {
    EarningsPaymentReports = "earningsPaymentReports",
    EmployersSeparateReports = "employersSeparateReports",
    BenefitsPaymentReports = "benefitsPaymentReports",
    RecordSubscription = "recordSubscription",
    Messages = "messages",
    CancellationOfEarningsPaymentReports = "cancellationOfEarningsPaymentReports",
    CancellationOfEmployersSeparateReports = "cancellationOfEmployersSeparateReports",
    CancellationOfBenefitsPaymentReports = "cancellationOfBenefitsPaymentReports",
    CancellationOfARecordSubscription = "cancellationOfARecordSubscription",
    CancellationOfARecordContainingEarningsPaymentReports = "cancellationOfARecordContainingEarningsPaymentReports",
    CancellationOfARecordContainingEmployersSeparateReports = "cancellationOfARecordContainingEmployersSeparateReports",
    CancellationOfARecordContainingBenefitsPaymentReports = "cancellationOfARecordContainingBenefitsPaymentReports",
    CancellationOfARecordContainingARecordSubscription = "cancellationOfARecordContainingARecordSubscription",
}

/** EarningsPaymentReportStatus enumeration */
export enum EarningsPaymentReportStatus {
    New = "new",
    Scheduled = "scheduled",
    Succeeded = "succeeded",
    Canceled = "canceled",
    Error = "error",
    Invalid = "invalid",
}

/** EmploymentCode enumeration */
export enum EmploymentCode {
    FullTime = "fullTime",
    PartTime = "partTime",
    NotAvailable = "notAvailable",
}

/** EmploymentEndingCode enumeration */
export enum EmploymentEndingCode {
    EmployeesResignation = "employeesResignation",
    Other = "other",
    TerminationGroundsRelatedToEmployeesPerson = "terminationGroundsRelatedToEmployeesPerson",
    FinancialAndProductionRelatedGrounds = "financialAndProductionRelatedGrounds",
    JointAgreement = "jointAgreement",
    Retirement = "retirement",
    TerminationOfaFixedTermEmployment = "terminationOfaFixedTermEmployment",
}

/** EmploymentEndingType enumeration */
export enum EmploymentEndingType {
    KevaCodes = "kevaCodes",
    BankOfFinlandCodes = "bankOfFinlandCodes",
    IncomesRegisterCodes = "incomesRegisterCodes",
}

/** EmploymentRegType enumeration */
export enum EmploymentRegType {
    KevasGroundsForRegistration = "kevasGroundsForRegistration",
    BankOfFinlandsGroundsForRegistration = "bankOfFinlandsGroundsForRegistration",
}

/** ExceptionCode enumeration */
export enum ExceptionCode {
    NoObligationToSocialInsurance = "noObligationToSocialInsurance",
    NoObligationToHealthInsurance = "noObligationToHealthInsurance",
    NoObligationToEarningsRelatedPensionInsurance = "noObligationToEarningsRelatedPensionInsurance",
    NoObligationToAccidentAndOccupationalDiseaseInsurance = "noObligationToAccidentAndOccupationalDiseaseInsurance",
    NoObligationToUnemploymentInsurance = "noObligationToUnemploymentInsurance",
    NotSubjectToSocialInsurance = "notSubjectToSocialInsurance",
    NotSubjectToEarningsRelatedPensionInsurance = "notSubjectToEarningsRelatedPensionInsurance",
    NotSubjectToAccidentAndOccupationalDiseaseInsurance = "notSubjectToAccidentAndOccupationalDiseaseInsurance",
    NotSubjectToUnemploymentInsurance = "notSubjectToUnemploymentInsurance",
    NotSubjectToHealthInsurance = "notSubjectToHealthInsurance",
    VoluntaryEarningsRelatedPensionInsurance = "voluntaryEarningsRelatedPensionInsurance",
}

/** FaultyControl enumeration */
export enum FaultyControl {
    OnlyInvalidItems = "onlyInvalidItems",
    EntireRecordIsRejected = "entireRecordIsRejected",
}

/** Gender enumeration */
export enum Gender {
    Male = "male",
    Female = "female",
}

/** IdType enumeration */
export enum IdType {
    BusinessId = "businessId",
    PersonalIdentificationNumber = "personalIdentificationNumber",
    Vat = "vat",
    Giin = "giin",
    TaxIdentificationNumber = "taxIdentificationNumber",
    FinnishTradeRegistrationNumber = "finnishTradeRegistrationNumber",
    ForeignBusinessRegistrationNumber = "foreignBusinessRegistrationNumber",
    ForeignPersonalIdentificationNumber = "foreignPersonalIdentificationNumber",
    Other = "other",
}

/** IncomeEarnerType enumeration */
export enum IncomeEarnerType {
    EmployedByStateEmploymentFund = "employedByStateEmploymentFund",
    JointOwnerWithPayer = "jointOwnerWithPayer",
    PartialOwner = "partialOwner",
    KeyEmployee = "keyEmployee",
    LeasedEmployeeLivingAbroad = "leasedEmployeeLivingAbroad",
    PersonWorkingInFrontierDistrict = "personWorkingInFrontierDistrict",
    PersonWorkingAbroad = "personWorkingAbroad",
    Athlete = "athlete",
    PerformingArtist = "performingArtist",
    RestrictedPeriodInFinland = "restrictedPeriodInFinland",
    NetOfTaxContract = "netOfTaxContract",
    Organization = "organization",
    PersonWorkingOnAlandFerry = "personWorkingOnAlandFerry",
    EntrepreneurOrFarmerNoPensionRequired = "entrepreneurOrFarmerNoPensionRequired",
    DimplomaticMission = "dimplomaticMission",
    Eppo = "eppo",
    LightEntrepreneur = "lightEntrepreneur",
}

/** IrScheduleAction enumeration */
export enum IrScheduleAction {
    Send = "send",
    Cancel = "cancel",
}

/** InsuranceCode enumeration */
export enum InsuranceCode {
    SubjectToSocialInsuranceContributions = "subjectToSocialInsuranceContributions",
    SubjectToEarningsRelatedPensionInsuranceContribution = "subjectToEarningsRelatedPensionInsuranceContribution",
    SubjectToHealthInsuranceContribution = "subjectToHealthInsuranceContribution",
    SubjectToUnemploymentInsuranceContribution = "subjectToUnemploymentInsuranceContribution",
    SubjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution = "subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution",
}

/** Language enumeration */
export enum Language {
    Fi = "fi",
    Sv = "sv",
    En = "en",
}

/** PaidAbsenceCauseCode enumeration */
export enum PaidAbsenceCauseCode {
    Illness = "illness",
    PartTimeSickLeave = "partTimeSickLeave",
    ParentalLeave = "parentalLeave",
    SpecialMaternityLeave = "specialMaternityLeave",
    Rehabilitation = "rehabilitation",
    ChildIllness = "childIllness",
    PartTimeChildCareLeave = "partTimeChildCareLeave",
    Training = "training",
    LeaveOfAbsence = "leaveOfAbsence",
    MilitaryRefresherTraining = "militaryRefresherTraining",
    MidWeekHoliday = "midWeekHoliday",
    AccruedHoliday = "accruedHoliday",
    OccupationalAccident = "occupationalAccident",
    AnnualLeave = "annualLeave",
    PartTimeAbsenceDueToRehabilitation = "partTimeAbsenceDueToRehabilitation",
    Other = "other",
}

/** PayerSubOrgType enumeration */
export enum PayerSubOrgType {
    KevasSubmitterCodes = "kevasSubmitterCodes",
    PayersOwnCodes = "payersOwnCodes",
    GovernmentAgencyIdentifier = "governmentAgencyIdentifier",
}

/** PayerType enumeration */
export enum PayerType {
    PublicSector = "publicSector",
    Household = "household",
    TemporaryEmployer = "temporaryEmployer",
    ForeignEmployer = "foreignEmployer",
    State = "state",
    UnincorporatedStateEnterpriseOrGovernmentalInstitution = "unincorporatedStateEnterpriseOrGovernmentalInstitution",
    SpecialisedAgency = "specialisedAgency",
    ForeignGroupCompany = "foreignGroupCompany",
    PoolOfHouseholdEmployers = "poolOfHouseholdEmployers",
}

/** PaymentType enumeration */
export enum PaymentType {
    Monthly = "monthly",
    Hourly = "hourly",
    ContractPay = "contractPay",
}

/** PensionActCode enumeration */
export enum PensionActCode {
    EmployeesEarningsRelatedPensionInsurance = "employeesEarningsRelatedPensionInsurance",
    PensionInsuranceForFarmers = "pensionInsuranceForFarmers",
    PensionInsuranceForTheSelfEmployed = "pensionInsuranceForTheSelfEmployed",
}

/** PensionProvIdCode enumeration */
export enum PensionProvIdCode {
    None = "none",
    FinnishCentreForPensions = "finnishCentreForPensions",
    ClergyOfTheOrthodoxChurch = "clergyOfTheOrthodoxChurch",
    KevaMemberOrganisations = "kevaMemberOrganisations",
    KevaÅlandLandskapsregeringsPensionssystem = "kevaÅlandLandskapsregeringsPensionssystem",
    KevaChurch = "kevaChurch",
    BankOfFinland = "bankOfFinland",
    KevaKelaEmploymentPensions = "kevaKelaEmploymentPensions",
    KevaState = "kevaState",
    Seafarers = "seafarers",
    Farmers = "farmers",
    Alandia = "alandia",
    Ilmarinen = "ilmarinen",
    Elo = "elo",
    Varma = "varma",
    Veritas = "veritas",
    Etera = "etera",
    UPM = "uPM",
    Sanoma = "sanoma",
    Sandvik = "sandvik",
    Kontino = "kontino",
    Yleisradio = "yleisradio",
    ABB = "aBB",
    LFashionGroup = "lFashionGroup",
    Honeywell = "honeywell",
    Telia = "telia",
    YaraSuomi = "yaraSuomi",
    Orion = "orion",
    Valio = "valio",
    OP = "oP",
    Verso = "verso",
    Apteekkien = "apteekkien",
    Viabek = "viabek",
    Reka = "reka",
}

/** ProfessionType enumeration */
export enum ProfessionType {
    StatisticsFinland = "statisticsFinland",
    Keva = "keva",
    BankOfFinland = "bankOfFinland",
    Trafi = "trafi",
}

/** RefPaymentType enumeration */
export enum RefPaymentType {
    EarningsRelatedPensionProvider = "earningsRelatedPensionProvider",
}

/** ReimbPaymentType enumeration */
export enum ReimbPaymentType {
    KelaDailyAllowanceApplication = "kelaDailyAllowanceApplication",
    KelaFamilyLeaveCompensation = "kelaFamilyLeaveCompensation",
}

/** RemunerationCode enumeration */
export enum RemunerationCode {
    DailyAllowance = "dailyAllowance",
    AccommodationBenefit = "accommodationBenefit",
    CarBenefit = "carBenefit",
    OtherBenefit = "otherBenefit",
}

/** ReportLogEventType enumeration */
export enum ReportLogEventType {
    Undefined = "undefined",
    Sent = "sent",
    Canceled = "canceled",
    Error = "error",
}

/** ResponsibilityCode enumeration */
export enum ResponsibilityCode {
    ContentIssues = "contentIssues",
    TechnicalIssues = "technicalIssues",
}

/** TermCode enumeration */
export enum TermCode {
    UntilFurtherNotice = "untilFurtherNotice",
    FixedTerm = "fixedTerm",
}

/** TransactionCode enumeration */
export enum TransactionCode {
    Unknown = "unknown",
    Ignored = "ignored",
    TimeRatePay = "timeRatePay",
    InitiativeFee = "initiativeFee",
    BonusPay = "bonusPay",
    ComplementaryWagePaidDuringBenefitPeriod = "complementaryWagePaidDuringBenefitPeriod",
    EmergencyWorkCompensation = "emergencyWorkCompensation",
    EveningWorkCompensation = "eveningWorkCompensation",
    EveningShiftAllowance = "eveningShiftAllowance",
    NoticePeriodCompensation = "noticePeriodCompensation",
    KilometreAllowanceTaxable = "kilometreAllowanceTaxable",
    MeetingFee = "meetingFee",
    SaturdayPay = "saturdayPay",
    ExtraWorkPremium = "extraWorkPremium",
    HolidayBonus = "holidayBonus",
    LectureFee = "lectureFee",
    CompensationForTrustPosition = "compensationForTrustPosition",
    OtherCompensation = "otherCompensation",
    WaitingTimeCompensation = "waitingTimeCompensation",
    WorkingConditionCompensation = "workingConditionCompensation",
    PartialPayDuringSickLeave = "partialPayDuringSickLeave",
    Commission = "commission",
    SundayWorkCompensation = "sundayWorkCompensation",
    BenefitArisingFromSyntheticOption = "benefitArisingFromSyntheticOption",
    PerformanceBonus = "performanceBonus",
    MonetaryCompensationFromWorkingTimeBank = "monetaryCompensationFromWorkingTimeBank",
    CompensationForAccruedTimeOff = "compensationForAccruedTimeOff",
    ShareIssueForEmployees = "shareIssueForEmployees",
    ContractPay = "contractPay",
    DamagesInConjunctionWithTermination = "damagesInConjunctionWithTermination",
    StandByCompensation = "standByCompensation",
    VoluntaryCompensationInConjunctionWithTermination = "voluntaryCompensationInConjunctionWithTermination",
    WeeklyRestCompensation = "weeklyRestCompensation",
    ProfitSharingBonus = "profitSharingBonus",
    AnnualHolidayCompensation = "annualHolidayCompensation",
    OvertimeCompensation = "overtimeCompensation",
    NightWorkAllowance = "nightWorkAllowance",
    NightShiftCompensation = "nightShiftCompensation",
    OtherRegularCompensation = "otherRegularCompensation",
    CompensationForUnusedCompensatoryLeave = "compensationForUnusedCompensatoryLeave",
    AccommodationBenefit = "accommodationBenefit",
    InterestBenefitForHousingLoan = "interestBenefitForHousingLoan",
    MealAllowance = "mealAllowance",
    CarBenefit = "carBenefit",
    CompensationForGoverningBodyMembership = "compensationForGoverningBodyMembership",
    ShareOfReserveDrawnFromPersonnelFund = "shareOfReserveDrawnFromPersonnelFund",
    MonetaryGiftForEmployees = "monetaryGiftForEmployees",
    KilometreAllowanceTaxExempt = "kilometreAllowanceTaxExempt",
    TreatmentFeeForMunicipalVeterinarian = "treatmentFeeForMunicipalVeterinarian",
    CompensationForUseEarnedIncome = "compensationForUseEarnedIncome",
    CompensationForUseCapitalIncome = "compensationForUseCapitalIncome",
    OtherTaxableBenefitForEmployees = "otherTaxableBenefitForEmployees",
    OtherTaxableIncomeDeemedEarnedIncome = "otherTaxableIncomeDeemedEarnedIncome",
    OtherFringeBenefit = "otherFringeBenefit",
    KinshipCarersFee = "kinshipCarersFee",
    StockOptions = "stockOptions",
    WagesPaidBySubstitutePayerIncludingSocialInsurance = "wagesPaidBySubstitutePayerIncludingSocialInsurance",
    WagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance = "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance",
    WagesPaidBySubstitutePayerIncludingUnemploymentInsurance = "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance",
    WagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance = "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance",
    WagesPaidBySubstitutePayerIncludingHealthInsurance = "wagesPaidBySubstitutePayerIncludingHealthInsurance",
    CompensationForEmployeeInvention = "compensationForEmployeeInvention",
    ReimbursementOfPrivateCaretakersExpenses = "reimbursementOfPrivateCaretakersExpenses",
    PrivateCaretakersFee = "privateCaretakersFee",
    ReimbursementOfFamilyDayCareProvidersExpenses = "reimbursementOfFamilyDayCareProvidersExpenses",
    TelephoneBenefit = "telephoneBenefit",
    DailyAllowance = "dailyAllowance",
    CapitalIncomePayment = "capitalIncomePayment",
    MealBenefit = "mealBenefit",
    ReimbursementOfCostsPaidToConciliator = "reimbursementOfCostsPaidToConciliator",
    NonWageCompensationForWork = "nonWageCompensationForWork",
    SupplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund = "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund",
    PensionPaidByEmployer = "pensionPaidByEmployer",
    DividendsBasedOnWages = "dividendsBasedOnWages",
    DividendsBasedOnNonWage = "dividendsBasedOnNonWage",
    EmployerSubsidisedCommuterTicketTaxExempt = "employerSubsidisedCommuterTicketTaxExempt",
    EmployerSubsidisedCommuterTicketTaxable = "employerSubsidisedCommuterTicketTaxable",
    EmployeeStockOption = "employeeStockOption",
    WagesTransferredToAthletesSpecialFund = "wagesTransferredToAthletesSpecialFund",
    WagesPaidFromAthletesSpecialFund = "wagesPaidFromAthletesSpecialFund",
    WagesForInsurancePurposes = "wagesForInsurancePurposes",
    TaxableReimbursementOfExpenses = "taxableReimbursementOfExpenses",
    PrivateDayCareAllowanceMunicipalSupplement = "privateDayCareAllowanceMunicipalSupplement",
    PrivateDayCareAllowanceWages = "privateDayCareAllowanceWages",
    PrivateDayCareAllowanceNonWage = "privateDayCareAllowanceNonWage",
    KilometreAllowancePaidByNonProfitOrganisation = "kilometreAllowancePaidByNonProfitOrganisation",
    DailyAllowancePaidByNonProfitOrganisation = "dailyAllowancePaidByNonProfitOrganisation",
    UnjustEnrichment = "unjustEnrichment",
    EmployeeStockOptionLowerMarketPrice = "employeeStockOptionLowerMarketPrice",
    RoyaltyPaidToNonResidentTaxpayer = "royaltyPaidToNonResidentTaxpayer",
    BicycleBenefitTaxExempt = "bicycleBenefitTaxExempt",
    BicycleBenefitTaxable = "bicycleBenefitTaxable",
    ConditionalStockOptions = "conditionalStockOptions",
    CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome",
    StockGrantPaidInMoney = "stockGrantPaidInMoney",
    EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney",
    EarningsFromJuELEmployerToLightEntrepreneur = "earningsFromJuELEmployerToLightEntrepreneur",
    CompensationCollectedForCarBenefit = "compensationCollectedForCarBenefit",
    WithholdingTax = "withholdingTax",
    ElectedOfficialFee = "electedOfficialFee",
    TaxAtSource = "taxAtSource",
    TaxAtSourceDeduction = "taxAtSourceDeduction",
    WagesPaid = "wagesPaid",
    ReimbursementCollectedForOtherFringeBenefits = "reimbursementCollectedForOtherFringeBenefits",
    OtherItemDeductibleFromNetWage = "otherItemDeductibleFromNetWage",
    NetWage = "netWage",
    EmployerPaidPremiumForCollectiveAdditionalPensionInsurance = "employerPaidPremiumForCollectiveAdditionalPensionInsurance",
    EmployerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution = "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution",
    EmployeesHealthInsuranceContribution = "employeesHealthInsuranceContribution",
    EmployeesPensionInsuranceContribution = "employeesPensionInsuranceContribution",
    EmployeesUnemploymentInsuranceContribution = "employeesUnemploymentInsuranceContribution",
    ReimbursementForEmployerSubsidisedCommuterTicket = "reimbursementForEmployerSubsidisedCommuterTicket",
    TaxPaidAbroad = "taxPaidAbroad",
    Distraint = "distraint",
    VoluntaryIndividualPensionInsurancePremium = "voluntaryIndividualPensionInsurancePremium",
    DeductionBeforeWithholding = "deductionBeforeWithholding",
    ReimbursementCollectedForBicycleBenefit = "reimbursementCollectedForBicycleBenefit",
}

/** UnpaidAbsenceCauseCode enumeration */
export enum UnpaidAbsenceCauseCode {
    Illness = "illness",
    PartTimeSickLeave = "partTimeSickLeave",
    ParentalLeave = "parentalLeave",
    SpecialMaternityLeave = "specialMaternityLeave",
    Rehabilitation = "rehabilitation",
    ChildIllness = "childIllness",
    PartTimeChildCareLeave = "partTimeChildCareLeave",
    Training = "training",
    JobAlternationLeave = "jobAlternationLeave",
    StudyLeave = "studyLeave",
    IndustrialAction = "industrialAction",
    InterruptionInWorkProvision = "interruptionInWorkProvision",
    LeaveOfAbsence = "leaveOfAbsence",
    MilitaryRefresherTraining = "militaryRefresherTraining",
    MilitaryService = "militaryService",
    LayOff = "layOff",
    ChildCareLeave = "childCareLeave",
    Other = "other",
}

/** WageUnitCode enumeration */
export enum WageUnitCode {
    Hour = "hour",
    Day = "day",
    Week = "week",
    Period = "period",
}

export enum EarningsPaymentReportExtensionsPaymentChannel {
    Undefined = "undefined",
    Test = "test",
    ZeroPayment = "zeroPayment",
    External = "external",
    PalkkausManual = "palkkausManual",
    PalkkausWS = "palkkausWS",
    PalkkausPersonal = "palkkausPersonal",
    PalkkausCfaPaytrail = "palkkausCfaPaytrail",
    PalkkausCfaReference = "palkkausCfaReference",
    PalkkausCfaFinvoice = "palkkausCfaFinvoice",
    PalkkausEcfaPaytrail = "palkkausEcfaPaytrail",
    PalkkausEcfaReference = "palkkausEcfaReference",
    PalkkausEcfaFinvoice = "palkkausEcfaFinvoice",
    PalkkausCfaTest = "palkkausCfaTest",
    AccountorGo = "accountorGo",
    TalenomOnline = "talenomOnline",
    TalenomCfa = "talenomCfa",
    HolviCfa = "holviCfa",
    FinagoSolo = "finagoSolo",
    Procountor = "procountor",
    Kevytyrittaja = "kevytyrittaja",
    VismaNetvisor = "vismaNetvisor",
    Askelma = "askelma",
    Briox = "briox",
    Lemonaid = "lemonaid",
    Laskupiste = "laskupiste",
    Holvi = "holvi",
    Kompassi = "kompassi",
    Domus = "domus",
}

export enum AvatarEntityType {
    Undefined = "undefined",
    Person = "person",
    Company = "company",
    PersonCreatedByEmployer = "personCreatedByEmployer",
    Partner = "partner",
}

export enum AvatarPictureType {
    Icon = "icon",
    Uploaded = "uploaded",
    Gravatar = "gravatar",
}

export enum WorkflowEventUi {
    Default = "default",
    Primary = "primary",
    Success = "success",
    Info = "info",
    Warning = "warning",
    Danger = "danger",
}

export enum Features {
    None = "none",
    IsActive = "isActive",
    IsEditable = "isEditable",
    IsRemovable = "isRemovable",
    IsOnHold = "isOnHold",
}

export enum InternationalDataPostedCertCode {
    FromFinlandA1CertificateOrAgreement = "fromFinlandA1CertificateOrAgreement",
    ToFinlandA1CertificateOrAgreement = "toFinlandA1CertificateOrAgreement",
    NonEUEEACountryOrNonSocialSecurityAgreementCountry = "nonEUEEACountryOrNonSocialSecurityAgreementCountry",
}

export enum WorkForm {
    NT1 = "nT1",
    NT2 = "nT2",
    EmployersReportOnPeriodsOfStayInFinland = "employersReportOnPeriodsOfStayInFinland",
    EmployeeLeasingNotice = "employeeLeasingNotice",
}

export enum EarningsPaymentDataPaymentChannel {
    Undefined = "undefined",
    Test = "test",
    ZeroPayment = "zeroPayment",
    External = "external",
    PalkkausManual = "palkkausManual",
    PalkkausWS = "palkkausWS",
    PalkkausPersonal = "palkkausPersonal",
    PalkkausCfaPaytrail = "palkkausCfaPaytrail",
    PalkkausCfaReference = "palkkausCfaReference",
    PalkkausCfaFinvoice = "palkkausCfaFinvoice",
    PalkkausEcfaPaytrail = "palkkausEcfaPaytrail",
    PalkkausEcfaReference = "palkkausEcfaReference",
    PalkkausEcfaFinvoice = "palkkausEcfaFinvoice",
    PalkkausCfaTest = "palkkausCfaTest",
    AccountorGo = "accountorGo",
    TalenomOnline = "talenomOnline",
    TalenomCfa = "talenomCfa",
    HolviCfa = "holviCfa",
    FinagoSolo = "finagoSolo",
    Procountor = "procountor",
    Kevytyrittaja = "kevytyrittaja",
    VismaNetvisor = "vismaNetvisor",
    Askelma = "askelma",
    Briox = "briox",
    Lemonaid = "lemonaid",
    Laskupiste = "laskupiste",
    Holvi = "holvi",
    Kompassi = "kompassi",
    Domus = "domus",
}

export enum StatusResponseDeliveryDataStatus {
    Unknown = "unknown",
    Received = "received",
    InProcess = "inProcess",
    Valid = "valid",
    RejectedAtReception = "rejectedAtReception",
    RejectedDuringProcessing = "rejectedDuringProcessing",
    Cancelled = "cancelled",
}

}